/**
 * The phone's clock can be minutes off. The countdown runs on the server's clock:
 * offset = server time − phone time, measured when a question arrives (half the round
 * trip is added, since the server stamped the time halfway). The server has the final
 * say anyway: a late answer is counted as wrong there.
 */
export function clockOffset(serverNowIso: string, sentAt: number, receivedAt: number): number {
  const rtt = Math.max(0, receivedAt - sentAt);
  return Date.parse(serverNowIso) + rtt / 2 - receivedAt;
}

/** Milliseconds left until `deadlineIso`, on the server's clock (never negative). */
export function remainingMs(deadlineIso: string, offset: number, phoneNow = Date.now()): number {
  return Math.max(0, Date.parse(deadlineIso) - (phoneNow + offset));
}

/** "1:05" or "12" seconds, for the countdown. */
export function formatSeconds(ms: number): string {
  const s = Math.ceil(ms / 1000);
  return s >= 60 ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}` : String(s);
}
